import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSkipNext$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSkipNext extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ebb8c1c5e2f6ab1eea768b7d22dfc96d8f585742', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '2fd1f2f0691d62e77ce4d2a333a7b58282f5b5db', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '8a68c20477666ca9a9e1f819bef69f0f08f6fd42', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.995 4.5a.5.5 0 0 0-.5-.5H16a.5.5 0 0 0-.5.5l-.005 13a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5zM6.386 17.836l6.455-6.443a.565.565 0 0 0 0-.786L6.386 4.164a.554.554 0 0 0-.786 0l-.387.387a.565.565 0 0 0 0 .786l5.668 5.658-5.668 5.668a.565.565 0 0 0 0 .786l.387.387a.553.553 0 0 0 .786 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-skip-next", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-skip-next"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-skip-next":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSkipNext$1);
            }
            break;
    } });
}

const CosmosIconSkipNext = CosmosIconSkipNext$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSkipNext, defineCustomElement };
